import * as React from "react";

const AlertIconSVG = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
        <path
            fill="#D32F2F"
            d="M1 22 12 3l11 19zm11-3q.424 0 .713-.288A.97.97 0 0 0 13 18a.97.97 0 0 0-.287-.712A.97.97 0 0 0 12 17a.97.97 0 0 0-.713.288A.97.97 0 0 0 11 18q0 .424.287.712.288.288.713.288m-1-3h2v-5h-2z"
        ></path>
    </svg>
);

export default AlertIconSVG;
